import { OrderColumn, OrderColumns } from 'communication/types/order/Order';
import { benchmarkStrategies } from 'widgets/outliers/data/benchmarksStrategies';
import { pnlStrategies } from 'widgets/outliers/data/pnlStrategies';
import { realisedPnlStrategy } from 'widgets/outliers/data/pnlStrategies/realised';
import { unrealisedPnlStrategy } from 'widgets/outliers/data/pnlStrategies/unrealised';

import {
    OutliersConfigState,
    OutliersPlType,
} from 'widgets/outliers/store/config/OutliersConfigState';

export function getOutliersRequiredOrderColumns(
    widgetConfig: OutliersConfigState,
    isLastPriceEnabled: boolean
): OrderColumns {
    const {
        benchmarkType,
        plType: plTypeConfig,
        visibleColumns,
    } = widgetConfig;

    const plType: OutliersPlType = isLastPriceEnabled
        ? plTypeConfig
        : 'realised';
    const ret: OrderColumns = [
        'qty',
        'pncD',
        ...benchmarkStrategies[benchmarkType].getRequiredColumns(),
        ...pnlStrategies[plType].requiredColumns,
    ];

    // Map the visible columns from config to order columns...
    for (const col of visibleColumns) {
        switch (col) {
            case 'pnl':
            case 'benchmarkPerformance':
                // Will be handled above by the strategies in use for the pnl
                break;
            case 'realisedPnl':
                ret.push(...realisedPnlStrategy.requiredColumns);
                break;
            case 'unrealisedPnl':
                ret.push(...unrealisedPnlStrategy.requiredColumns);
                break;
            case 'totalPnl':
                ret.push(...unrealisedPnlStrategy.requiredColumns);
                ret.push(...realisedPnlStrategy.requiredColumns);
                break;
            case 'arrivalPAdj':
                ret.push('exCostTx');
                ret.push('arrivalP');
                ret.push('side');
                break;
            case 'arrivalPDAdj':
                ret.push('exCostTx');
                ret.push('arrivalPD');
                ret.push('side');
                break;
            default:
                ret.push(col as OrderColumn);
        }
    }

    return ret;
}
